// extracted by mini-css-extract-plugin
export default {"timerContent":"styles_timerContent__hXuXx","time":"styles_time__y2Bzy","alertTime":"styles_alertTime__+sY43"};